import { useEffect, useState } from "react";
import { ShipCard } from "../../../Cards/ShipCard";
import { useShipContext } from "../../../../context/shipContext";
import { PiCheckCircleBold } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

export function OrderConfirmationForm() {
  const { state: shipState } = useShipContext();
  const navigate = useNavigate();

  const REDIRECT_URL = "/dashboard/orders";
  const REDIRECT_TIMEOUT = 10000;
  const [progress, setProgress] = useState(0);

  // Handle redirect timer + progress bar fill
  useEffect(() => {
    const start = Date.now();

    const interval = setInterval(() => {
      const elapsed = Date.now() - start;
      const pct = Math.min((elapsed / REDIRECT_TIMEOUT) * 100, 100);
      setProgress(pct);
    }, 50);

    const redirectTimer = setTimeout(() => {
      navigate(REDIRECT_URL);
    }, REDIRECT_TIMEOUT);

    return () => {
      clearInterval(interval);
      clearTimeout(redirectTimer);
    };
  }, [navigate]);

  return (
    <div data-testid="ship-confirmation-step">
      <motion.div
        initial={{ opacity: 0, scale: 0.98 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3 }}
      >
        <ShipCard>
          <div className="flex items-start">
            <PiCheckCircleBold className="text-green-500 mr-5 text-5xl" />

            <div>
              <div className="flex items-center gap-2 text-sm text-gray-500">
                <span>Reference</span>
                <span className="font-mono text-gray-700 bg-gray-100 px-2 py-0.5 rounded">
                  {shipState.orderId}
                </span>
              </div>

              <div className="text-3xl font-semibold mt-3 mb-2">
                Thank you for your order
              </div>

              <div className="text-sm text-gray-600">
                Redirecting to your Orders in a moment...
              </div>

              {/* Progress Bar */}
              <div className="w-full h-1 bg-gray-200 rounded-full mt-4 overflow-hidden">
                <motion.div
                  className="h-full bg-blue-500"
                  initial={{ width: 0 }}
                  animate={{ width: `${progress}%` }}
                  transition={{ ease: "linear" }}
                />
              </div>
            </div>
          </div>
        </ShipCard>
      </motion.div>
    </div>
  );
}
